import { useRouter } from 'vue-router'

export function routeToAnalyticsName(router, route) {
  const resolved = router.resolve(route)
  if (!resolved) {
    return ''
  }
  if (resolved.name === 'GamesByGroup') {
    return resolved.params.group.toLowerCase()
  }
  if (resolved.name === 'GamesBySubGroup') {
    const group = resolved.params.group ? resolved.params.group + '-' : ''
    const subgroup = resolved.params.subgroup

    return (group + subgroup).toLowerCase()
  }
  if (resolved.name === 'GamePageNew') {
    const manufacturer = resolved.params.manufacturer ? resolved.params.manufacturer + '-' : ''
    const game = resolved.params.game

    return (manufacturer + game).toLowerCase()
  }
  return resolved.name.toLowerCase()
}

export const useAnalytics = () => {
  const router = useRouter()

  return {
    routeToAnalyticsName: (route) => routeToAnalyticsName(router, route),
  }
}
